/* eslint-disable @typescript-eslint/explicit-function-return-type */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { action } from 'typesafe-actions';

import { ProductData } from '../product/types';

import {
  AgreementsProps,
  AuthActionStep,
  AuthActionTypes,
  CustomerData,

  // iPassword,
  User,
  UserAddresses,
  UserCard,
  UserCreate,
} from './types';

export function signInRequest({
  email,

  password,
}: {
  email: string;

  password: string;
}) {
  return action(AuthActionTypes.SIGN_IN_REQUEST, {
    email,

    password,
  });
}

export function signInSocialRequest({
  email,

  provider,

  provider_id,

  customer_name,
}: {
  email: string;

  provider: string;

  provider_id: string;

  customer_name: string;
}) {
  return action(AuthActionTypes.SIGN_IN_SOCIAL_REQUEST, {
    email,

    provider,

    provider_id,

    customer_name,
  });
}

export function signInSuccess({
  user,
  agreement,
}: {
  user: User;
  agreement?: boolean;
}) {
  return action(AuthActionTypes.SIGN_IN_SUCCESS, {
    user,
    agreement,
  });
}

export function signInSocialSuccess({
  user,
  agreement,
}: {
  user: User;
  agreement?: boolean;
}) {
  return action(AuthActionTypes.SIGN_IN_SOCIAL_SUCCESS, {
    user,
    agreement,
  });
}

export function signInFailure(
  socialRegisterPass?: boolean,
  messageError?: string,
) {
  return action(AuthActionTypes.SIGN_IN_FAILURE, {
    socialRegisterPass,
    messageError,
  });
}

export function signOutSucess() {
  return action(AuthActionTypes.SIGNOUT_REQUEST_SUCESS);
}

export function signOut() {
  return action(AuthActionTypes.SIGNOUT_REQUEST);
}

export function resetLogout() {
  return action(AuthActionTypes.RESET_LOGOUT);
}

export function userPaymentRequest(cart_id: string, method: string) {
  return action(AuthActionTypes.PAYMENT_REQUEST, {
    cart_id,

    method,
  });
}

export function userPaymentSelectedRequest(method_id: string) {
  return action(AuthActionTypes.PAYMENT_SEL_REQUEST, {
    method_id,
  });
}

export function userPaymentRemovedRequest(method_id: string) {
  return action(AuthActionTypes.PAYMENT_REMOVE_REQUEST, {
    method_id,
  });
}

export function userAddressRequest(

  address: UserAddresses,
) {
  return action(AuthActionTypes.ADDRESS_REQUEST, {

    address,
  });
}

export function userAddressGetSuccess(address: UserAddresses[]) {
  return action(AuthActionTypes.CUSTOMER_GET_ADDRESS_SUCCESS, {
    address,
  });
}

export function userAddressSuccess(address_id: string) {
  return action(AuthActionTypes.ADDRESS_SUCCESS, {
    address_id,
  });
}

export function userAddressSelectedRequest(
  address: UserAddresses,
) {
  return action(AuthActionTypes.ADDRESS_SELECTED_REQUEST, {
    address,
  });
}

export function userAddressRemovedRequest(
  address_id: UserAddresses,
  is_open_summary?: boolean,
) {
  return action(AuthActionTypes.ADDRESS_REMOVED_REQUEST, {
    address_id,
    is_open_summary,
  });
}

export function userAddressRemovedSuccesss() {
  return action(AuthActionTypes.ADDRESS_REMOVED_SUCCESS);
}

export function userSavePaymentESitef(card: UserCard) {
  return action(AuthActionTypes.CARD_ESITEF_REQUEST, {
    card,
  });
}

export function userSavePaymentESitefSuccess(card: UserCard[]) {
  return action(AuthActionTypes.CARD_ESITEF_SUCCESS, {
    card,
  });
}

export function userSavePaymentESitefError(card: UserCard[]) {
  return action(AuthActionTypes.CARD_ESITEF_ERROR, {
    card,
  });
}

export function userListPaymentRequest() {
  return action(AuthActionTypes.CARD_LIST_REQUEST, { });
}

export function userListPaymentSuccess(card: UserCard[]) {
  return action(AuthActionTypes.CARD_LIST_SUCCESS, { card });
}

export function customerClear() {
  return action(AuthActionTypes.CUSTOMER_CLEAR);
}

export function customerCreateRequest(
  customer: CustomerData,

  step?: AuthActionStep,

  type?: 'userSignIn' | 'customerCreateCard',

  messageSuccess?: string,

  messageError?: string,
) {
  return action(AuthActionTypes.CUSTOMER_CREATE_REQUEST, {
    customer,
    step,
    type,
    messageSuccess,
    messageError,
  });
}

export function customerCreateSuccess(customer: User, step?: AuthActionStep) {
  return action(AuthActionTypes.CUSTOMER_CREATE_SUCCESS, { customer, step });
}

export function customerIsExist(message: string) {
  return action(AuthActionTypes.CUSTOMER_IS_EXIST, { message });
}

export function customerStepRequest(step: AuthActionStep) {
  return action(AuthActionTypes.CUSTOMER_SET_STEP, { step });
}

export function customerUpdateRequest(
  customer: CustomerData,
  step?: AuthActionStep,
) {
  return action(AuthActionTypes.CUSTOMER_UPDATE_REQUEST, {
    customer,
    step,
  });
}

export function customerUpdateSuccess(customer: CustomerData) {
  return action(AuthActionTypes.CUSTOMER_UPDATE_SUCCESS, {
    customer,
  });
}

export function customerUpdateMethodsSuccess(methods: UserCard[]) {
  return action(AuthActionTypes.CUSTOMER_UPDATE_METHODS_SUCCESS, {
    methods,
  });
}

export function customerUpdateAddressSuccess(address: UserAddresses[]) {
  return action(AuthActionTypes.CUSTOMER_UPDATE_ADDRESS_SUCCESS, {
    address,
  });
}

export function customerUpdateFailure() {
  return action(AuthActionTypes.CUSTOMER_UPDATE_FAILURE);
}

export function customerSendMailRequest(name: string, email: string) {
  return action(AuthActionTypes.CUSTOMER_SEND_MAIL, { name, email });
}

export function customerConfirmMailRequest(conf_code: string, email: string) {
  return action(AuthActionTypes.CUSTOMER_CONFIRM_MAIL, { conf_code, email });
}

export function customerConfirmMailSuccess() {
  return action(AuthActionTypes.CUSTOMER_CONFIRM_MAIL_SUCCESS);
}

export function customerCEPRequest(postcode: string) {
  return action(AuthActionTypes.CUSTOMER_CEP_REQUEST, { postcode });
}

export function customerCEPSuccess(address: UserAddresses) {
  return action(AuthActionTypes.CUSTOMER_CEP_SUCCESS, { address });
}

export function customerCEPClear() {
  return action(AuthActionTypes.CUSTOMER_CEP_CLEAR);
}

export function customerSaveAddrewssRequest(
  address: UserAddresses,
) {
  return action(AuthActionTypes.CUSTOMER_CREATE_ADDRESS_REQUEST, {
    address,
  });
}

export function customerSaveAddrewssSuccess(address: UserAddresses) {
  return action(AuthActionTypes.CUSTOMER_CREATE_ADDRESS_SUCCESS, {
    address,
  });
}

export function customerForgotPassword(email: string) {
  return action(AuthActionTypes.CUSTOMER_FORGOT_PASS, { email });
}

export function customerForgotPasswordSuccess(message: string) {
  return action(AuthActionTypes.CUSTOMER_FORGOT_PASS_SUCCESS, { message });
}

export function customerForgotPasswordClear() {
  return action(AuthActionTypes.CUSTOMER_FORGOT_PASS_CLEAR, {});
}

export function customerFavoriteSave(customer_id: string, product_id: string) {
  return action(AuthActionTypes.CUSTOMER_FAVORITE_SAVE, {
    customer_id,
    product_id,
  });
}

export function customerFavoriteSaveSuccess(favorite: ProductData) {
  return action(AuthActionTypes.CUSTOMER_FAVORITE_SAVE_SUCCESS, { favorite });
}

export function customerFavoriteRemove(favorite: ProductData) {
  return action(AuthActionTypes.CUSTOMER_FAVORITE_REMOVE, { favorite });
}

export function customerFavoriteList() {
  return action(AuthActionTypes.CUSTOMER_FAVORITE_LIST);
}

export function customerFavoriteListSuccess(favorites: ProductData[]) {
  return action(AuthActionTypes.CUSTOMER_FAVORITE_LIST_SUCCESS, { favorites });
}

export function customerAgreementRequest(type: string, version: string) {
  return action(AuthActionTypes.CUSTOMER_AGREEMENT_REQUEST, { type, version });
}

export function customerAgreementRequestSuccess(agreement: AgreementsProps) {
  return action(AuthActionTypes.CUSTOMER_AGREEMENT_REQUEST_SUCCESS, {
    agreement,
  });
}

export function customerAgreementAccepted(agreement_id?: string) {
  return action(AuthActionTypes.CUSTOMER_AGREEMENT_ACCEPTED, {
    agreement_id,
  });
}

export function customerAgreementAcceptedSuccess(agreement: boolean) {
  return action(AuthActionTypes.CUSTOMER_AGREEMENT_ACCEPTED_SUCCESS, {
    agreement,
  });
}

export function clearMessage() {
  return action(AuthActionTypes.CLEAR_MESSAGE, {});
}

export function clearLoading() {
  return action(AuthActionTypes.CLEAR_LOADING, {});
}

export function verifyCustomerIsExist(
  userCreate: UserCreate,
  step: AuthActionStep,
  messageCustomerIsExist: string,
) {
  return action(AuthActionTypes.VERIFY_CUSTOMER_IS_EXIST, {
    userCreate,
    step,
    messageCustomerIsExist,
  });
}

export function verifyCustomerIsExistSucess(
  userCreate: UserCreate,
  step: AuthActionStep,
) {
  return action(AuthActionTypes.VERIFY_CUSTOMER_IS_EXIST_SUCESS, {
    userCreate,
    step,
  });
}

// verificar se email existe

export function verifyEmailExist(email: string, messageSuccess?: string) {
  return action(AuthActionTypes.VERIFY_EMAIL_EXIST, { email, messageSuccess });
}

export function verifyEmailExistSuccess() {
  return action(AuthActionTypes.VERIFY_EMAIL_EXIST_SUCCESS);
}

export function verifyEmailExistError() {
  return action(AuthActionTypes.VERIFY_EMAIL_EXIST_ERROR);
}

export function updateCustomerCreate(
  userCreate: UserCreate,
  step: AuthActionStep,
) {
  return action(AuthActionTypes.UPDATE_CUSTOMER_CREATE, { userCreate, step });
}

export function removeAccountCustomer(messageSuccess: string) {
  return action(AuthActionTypes.REMOVE_ACCOUNT_CUSTOMER, {
    messageSuccess,
  });
}

//reset senha

export function customerResetPassword({
  token,
  email,
  password,
  password_confirmation,
}: {
  token: string | null;
  email: string;
  password: string;
  password_confirmation: string;
}) {
  return action(AuthActionTypes.CUSTOMER_RESET_PASS, {
    token,
    email,
    password,
    password_confirmation,
  });
}

export function customerResetPasswordSuccess(message: string) {
  return action(AuthActionTypes.CUSTOMER_RESET_PASS_SUCCESS, { message });
}
